import React from 'react';
import { cn } from '../../lib/utils';

export const Skeleton = ({ className, ...props }) => (
  <div
    className={cn('animate-pulse rounded-md bg-gray-200', className)}
    {...props}
  />
);

export const SkeletonTable = ({ rows = 5, cols = 3 }) => (
  <div className="w-full overflow-auto">
    <table className="w-full text-sm">
      <thead>
        <tr className="border-b">
          {Array.from({ length: cols }).map((_, i) => (
            <th key={i} className="h-12 px-4 text-left">
              <Skeleton className="h-4 w-24" />
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: rows }).map((_, rowIdx) => (
          <tr key={rowIdx} className="border-b">
            {Array.from({ length: cols }).map((_, colIdx) => (
              <td key={colIdx} className="p-4">
                <Skeleton className="h-4 w-full" />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
